import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './token.interceptor';
import { ErrorInterceptor } from './error.interceptor';
import { BodyInterceptor } from './body.interceptor';
import { UrlInterceptor } from './url.interceptor';

export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BodyInterceptor, multi: true },
    // Url must be the last one because the others checks on this
    { provide: HTTP_INTERCEPTORS, useClass: UrlInterceptor, multi: true }
];
